import NodeHelper from "../helpers/node_helper";
import NodeHandler from "../node_handler";


class AccordionItem extends NodeHandler{
    __init_dom_schema(){
        return {
            paddle: {
                selector: '.js-accordion-item__paddle',
            },
            slide: {
                selector: '.js-accordion-item__slide',
            },
            content: {
                selector: '.js-accordion-item__content',
            },
        }
    }
    __init() {
        this.id = this.node.getAttribute('data-id')
        this.registerEvents('onToggled')
        this.dom.paddle.addEventListener('click', this.onPaddleClicked.bind(this))
    }
    onPaddleClicked(event){
        this.toggle()
        this.dispatchEvent('onToggled', {
            sender: this,
        })
    }
    toggle(bool = null){
        if(bool === null){
            bool = !this.node.classList.contains('is--active')
        }
        NodeHelper.ToggleClass(this.node, 'is--active', bool)
        this.is_active = this.node.classList.contains('is--active')
        this.resetSlideHeight()
    }
    resetSlideHeight(){
        let height
        if(this.is_active){
            const rect = this.dom.content.getBoundingClientRect()
            height = rect.height
        }else{
            height = 0
        }
        this.dom.slide.style.height = `${height}px`;
    }
}

class Accordion extends NodeHandler{
    __init_dom_schema(){
        return {
            items: {
                selector: '.js-accordion-item',
                is_single: false,
            }
        }
    }
    __init() {
        console.log(this)
        this.items = []
        for(const dom_item of this.dom.items){
            const item = new AccordionItem(dom_item)
            item.addEventListener('onToggled', this.onItemToggled.bind(this))
            this.items.push(item)
        }
    }
    onItemToggled(args){
        if(this?.args?.close_prev_item){
            for(const item of this.items){
                if(item !== args.sender){
                    item.toggle(false)
                }
            }   
        }
    }
}

export default Accordion